import { useDispatch } from 'react-redux';
import { clearExchangeVariants } from '@entities/exchange';

export function useClearExchangeVariants() {
	const dispatch = useDispatch();

	const onClearExchangeVariants = () => {
		dispatch(clearExchangeVariants());
	};

	return { onClearExchangeVariants };
}
